import { useState, useEffect } from 'react';
import { getCurrentUserOrganizationId } from '@/lib/supabase/products/organization';

export const useOrganizationData = (initialOrganizationId?: string | null) => {
  const [organizationId, setOrganizationId] = useState<string | null>(initialOrganizationId || null);
  
  // Fetch organization ID on component mount if not provided
  useEffect(() => {
    const fetchOrganizationId = async () => {
      // If organization ID was provided as a prop, use it
      if (organizationId) {
        console.log('Using provided organization ID:', organizationId);
        return;
      }
      
      // Otherwise try to get from localStorage
      const localOrgId = localStorage.getItem('currentOrganizationId');
      if (localOrgId) {
        console.log('Organization ID loaded from localStorage:', localOrgId);
        setOrganizationId(localOrgId);
        return;
      }
      
      // Last resort - fetch from database
      const orgId = await getCurrentUserOrganizationId();
      setOrganizationId(orgId);
      console.log('Organization ID loaded from database:', orgId);
    };
    
    fetchOrganizationId();
  }, [organizationId]);
  
  return { organizationId };
};
